import { useQuery } from '@apollo/client'
import {
  BillingAddressForm,
  CurrentSubscription,
  Invoices,
  Licences,
  PaymentMethodManagement,
} from 'components/me/subscriptionManagement'
import StripeProvider from 'context/StripeProvider'
import styled from 'styled-components'
import { checkOwner } from 'utils/subscription'

import { SUBSCRIPTION } from '@/graphql/queries/user'

const SubscriptionManagement = () => {
  const userQuery = useQuery(SUBSCRIPTION)

  if (userQuery.loading || !userQuery.data?.me) {
    return null
  }

  const { me } = userQuery.data
  const { quantity, user, plan } = me.subscription
  const isOwner = checkOwner(me.id, user.id)

  return (
    <>
      {isOwner && me?.subscription?.platform === 'stripe' ? (
        <>
          {quantity !== 1 ? (
            <>
              <p className="text-content">
                {`Vous souhaitez ${plan.interval === 'year' && plan.isTeam === true ? 'augmenter' : 'augmenter ou diminuer'} votre nombre de licences ? Contactez-nous sur `}
                <a href={`mailto:${import.meta.env.VITE_CONTACT_ADDRESS}`}>{import.meta.env.VITE_CONTACT_ADDRESS}</a>
              </p>
              <Licences />
              <Separator />
            </>
          )
            : null
          }
          <StripeProvider>
            <PaymentMethodManagement />
          </StripeProvider>
          <Separator />
          {isOwner && plan.metadata.threshold > 1 ? (
            <>
              <BillingAddressForm />
              <Separator />
            </>
          )
            : null
          }
          <Invoices />
        </>
      )
        : null
      }
      <Separator />
      <CurrentSubscription isOwner={isOwner} />
    </>
  )
}

const Separator = styled.hr`
  width: 100%;
  margin: 1.5rem 0;
  border: solid 0.5px #a2bfdd;
`
export default SubscriptionManagement
